import { render } from "./ConfirmationScreen.vue?vue&type=template&id=33469bf2"
import script from "./ConfirmationScreen.vue?vue&type=script&lang=js"
export * from "./ConfirmationScreen.vue?vue&type=script&lang=js"

import "./ConfirmationScreen.vue?vue&type=style&index=0&id=33469bf2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__